import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {getJobBidDetailApi, getJobDetailApi} from "../../API/API";

function* getJobDetailSaga(action) {
    // console.log("in saga");
    try {
        const { _id } = action.payload;
        const response = yield call(() => getJobDetailApi(_id));
        yield put({ type: types.GET_JOBDETAIL_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_JOBDETAIL_FAILURE, error });
    }
}

function* getJobBidDetailSaga(action) {
    // console.log("in saga");
    try {
        const { _id } = action.payload;
        const response = yield call(() => getJobBidDetailApi(_id));
        yield put({ type: types.GET_JOB_BID_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_JOB_BID_FAILURE, error });
    }
}

export function* watchGetJobDetailSaga() {
    yield takeEvery(types.GET_JOBDETAIL_REQUESTED, getJobDetailSaga);
}

export function* watchGetJobBidDetailSaga() {
    yield takeEvery(types.GET_JOB_BID_DETAILS, getJobBidDetailSaga);
}
